import { Component, OnInit, Renderer2, ViewChild, HostListener, ElementRef, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.css']
})
export class SwitchComponent implements OnInit {

  @ViewChild('switch') switch: ElementRef;
  switch_state = false;
  @Input() title;
  @Input() values;
  @Output() chosen = new EventEmitter();
  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    this.renderer.setStyle(this.switch.nativeElement, 'transform', 'rotate(-45deg)');
  }

  switchIt() {
    console.log('switch it');
    this.switch_state = !this.switch_state;
    const i = this.switch_state ? 1 : 0;
    this.chosen.emit(this.values[i]);
    if (this.switch_state) {
    this.renderer.setStyle(this.switch.nativeElement, 'transform', 'rotate(45deg)');
    } else {
      this.renderer.setStyle(this.switch.nativeElement, 'transform', 'rotate(-45deg)');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/switch/switch.component.ts